module.exports = __webpack_public_path__ + "static/img/about.f9806a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about.jpg
// module id = OU5M
// module chunks = 1